export default __webpack_public_path__ + "static/media/allgemein_19.0160e349.jpg";